// KontractAI design system color tokens.
//
// Aesthetic: refined utilitarian / legal-grade.
// Typography: Source Serif 4 (display) + Outfit (UI).
//
// All color references in components should go through this object so
// theme changes happen in one place. Adding a new token: add the field
// here and the type-checker will let you reference it via T.NEW_NAME.

export const T = {
  bg: "#F5F7FA", bg2: "#FFFFFF", bg3: "#F0F2F5", bg4: "#E8ECF0", bgHov: "#EDF0F4",
  brd: "#DDE1E8", brdFocus: "#2B7A3E", brdSubtle: "#EEF0F3",
  tx: "#1A1F2E", txM: "#5A6278", txD: "#8B93A8", txW: "#fff",
  acc: "#2B7A3E", accH: "#348A48", accS: "rgba(43,122,62,.08)", accS2: "rgba(43,122,62,.12)",
  grn: "#2B9E5A", grnS: "rgba(43,158,90,.08)",
  ylw: "#C68A1A", ylwS: "rgba(198,138,26,.08)",
  red: "#D04040", redS: "rgba(208,64,64,.08)",
  prp: "#7B5EA7", prpS: "rgba(123,94,167,.08)",
  cyn: "#1A8A9E", cynS: "rgba(26,138,158,.08)",
  orn: "#C06A20", ornS: "rgba(192,106,32,.08)",
  pnk: "#B04A7A", pnkS: "rgba(176,74,122,.08)",
  blu: "#2B6CB0", bluS: "rgba(43,108,176,.08)",
};
